import React from "react"

import Layout from "../components/App/layout"

const CustomError = () => {
  return (
    <Layout>
      <div className="not-found-image">{/* <h1>Not Found!</h1> */}</div>
    </Layout>
  )
}

export default CustomError
